import { render, staticRenderFns } from "./RecepcionFormComponent.vue?vue&type=template&id=1c682932&scoped=true&"
import script from "./RecepcionFormComponent.vue?vue&type=script&lang=js&"
export * from "./RecepcionFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./RecepcionFormComponent.vue?vue&type=style&index=0&id=1c682932&scoped=true&lang=css&"
import style1 from "./RecepcionFormComponent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c682932",
  null
  
)

export default component.exports